import { WithArticleTypeProps } from '../../../../hooks/api/articles';
import ViewContent from '../View/Content';
import { useSingleArticleByType } from '../../../../hooks/api/useSingleArticleByType';

export default function ArticleByTypeView({
  articleType,
}: WithArticleTypeProps): React.ReactNode | null {
  const getSingleArticleByType = useSingleArticleByType(articleType);
  const { data, loading } = getSingleArticleByType;
  const isSpecialType =
    data?.articleType === 'history' || data?.articleType === 'psychology';

  const simplifiedFinal = !loading && !isSpecialType;
  return (
    <ViewContent
      data={data}
      loading={loading}
      id={data?.id}
      simplified={simplifiedFinal}
    />
  );
}
